<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Visiting Hours</h3>
            <p class="bullet03 depth">Visiting hours are allowed for a limited period of time to guard patient's safety and prevent infection. Please observe the suggested visiting hours.</p>
            <p class="bullet03 depth">Each visit is limited to 2 hours and access to a patient's room is permitted from 18:00 to 20:00 on weekdays and from 10:00 to 12:00 and from 18:00 to 20:00 on weekends and holidays. No ward access is allowed after 20:00.</p>
            <p class="bullet03 depth">Visiting hours to the intensive care unit are from 13:00 to 13:30 and from 19:00 to 19:30.</p>
            <p class="bullet03 depth">A guardian holding a guardian access card provided during the admission process can access any time.</p>
            <p class="bullet03 depth">If the patient is in quarantine due to a low level of immunity or infectious disease, patient visit is restricted to prevent contagion of the infection and to protect the patient.</p>
            <p class="bullet03 depth">In case that you do not want any visitor for privacy protection, please let the administration team or nurse office know at the admission.</p>
            <p class="bullet03 depth">We wish to expect your cooperation for registering your name for the purpose of visitor management.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Visiting Restriction</h3>
            <p class="bullet03 depth">For smooth recovery and stability of patients and prevention of infection, children aged 13 or under are prohibited from visiting the infection ward and ICU.</p>
            <p class="bullet03 depth">Visiting of any guardian with a cold or other infectious disease is restricted.</p>
            <p class="bullet03 depth">Any potential source of infection such as plants, flower pots, or animals cannot be carried inside when visiting.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>